import React from 'react';
import PropTypes from 'prop-types';

const ClickableImageComponent =
({
  isActive,
  activeImageSource,
  disabledImageSource,
  activeHoverText,
  disabledHoverText,
  height,
  marginTop,
  marginBottom,
  marginRight,
  marginLeft,
  onClick
}) => (
  <div>
    <img
      name={activeImageSource + 'icon'}
      src={isActive ? activeImageSource : disabledImageSource}
      title={isActive ? activeHoverText : disabledHoverText}
      style={{
        height: height || 30,
        marginTop: marginTop || -10,
        marginBottom: marginBottom || -10,
        marginRight: marginRight || '0px',
        marginLeft: marginLeft || '0px'
      }}
      onClick={() => {
        if (onClick) {
          onClick();
        } }
      }
    />
  </div>
);

ClickableImageComponent.propTypes = {
  isActive: PropTypes.bool,
  activeImageSource: PropTypes.string.isRequired,
  disabledImageSource: PropTypes.string.isRequired,
  activeHoverText: PropTypes.string,
  disabledHoverText: PropTypes.string,
  height: PropTypes.number,
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number,
  marginRight: PropTypes.string,
  marginLeft: PropTypes.string,
  onClick: PropTypes.func,
};

export default ClickableImageComponent;


// WEBPACK FOOTER //
// src/Components/ClickableImageComponent.jsx